import React, { useState, useEffect } from 'react';
import './SpanishLinks.css';
import axios from 'axios';

function SpanishLinks() {
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get('/spanish-links-table.json');
        setLinks(response.data);
      } catch (err) {
        console.error("Error fetching links:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const categories = !isLoading && links ? [...new Set(links.map(link => link.category))] : [];

  const filteredLinks = selectedCategory
    ? links.filter(link => link.category === selectedCategory)
    : links;

  const handleCategoryClick = (category) => {
    setSelectedCategory(category === selectedCategory ? null : category);
  };

  return (
    <div className="spanish-links-container">
      {isLoading ? (
        <div>Loading links...</div>
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        <>
          <div className="category-sidebar">
            <button
              className={`category-sidebar-button ${selectedCategory === null ? 'active' : ''}`}
              onClick={() => handleCategoryClick(null)}
            >
              All
            </button>
            {categories.map(category => (
              <button
                key={category}
                className={`category-sidebar-button ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="spanish-links-grid">
            {filteredLinks.map(link => (
         <a
  key={link.name}
  href={link.url}
  target="_blank"
  rel="noopener noreferrer"
  className="spanish-link-item"
>
  <img src={link.logo} alt={link.name} className="spanish-link-logo" />
  <span className="spanish-link-name">{link.name}</span>
</a>

            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default SpanishLinks;